interface Props {
  onClick: () => void;
  disabled?: boolean;
  title?: string;
}

// Top-right page-level download trigger. Shared across project/billing/audit screens.
export function DownloadButton({ onClick, disabled, title = 'Download' }: Props) {
  return (
    <div className="pull-right" style={{ paddingTop: 15, paddingRight: 15 }}>
      <button
        className="btn btn-default"
        style={{ fontSize: 'larger' }}
        title={title}
        aria-label={title}
        disabled={disabled}
        onClick={onClick}
      >
        <i className="fas fa-download" aria-hidden="true" />
      </button>
    </div>
  );
}
